import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import FooterBrand from "./footer/FooterBrand";
import FooterQuickLinks from "./footer/FooterQuickLinks";
import FooterContact from "./footer/FooterContact";

const Footer = () => {
  const { t } = useLang();

  const goToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="site-footer" className="bg-[#1A1F24] text-[#F9F6F0] pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <FooterBrand tagline={t.footer.tagline} />
          <FooterQuickLinks
            heading={t.footer.quickLinks}
            labels={t.nav}
            onNavigate={goToSection}
          />
          <FooterContact
            heading={t.footer.legal}
            privacyLabel={t.footer.privacy}
            termsLabel={t.footer.terms}
          />
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <p className="text-xs text-[#A0AEC0]">{t.footer.copyright}</p>
          <p className="text-xs text-[#A0AEC0]">hrmembers.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
